import TabButton from "./TabButton";

const TabContainer = ({ tabs, activeTab, onTabClick }) => {
  return (
    <div className="flex gap-1 font-semibold">
      {tabs.map((tab) => (
        <TabButton
          key={tab}
          label={tab}
          isActive={tab === activeTab}
          onClick={() => onTabClick(tab)}
        />
      ))}
    </div>
  );
};

export default TabContainer;
